import {Box, VStack, Text, NumberInput} from "@chakra-ui/react";
import {useCalculator} from "../context/calculatorContext/context";

const ProductCard = (props) => {
  const {data} = props;
  const {quantityChangeFunction} = useCalculator();
  const {name, cpu, ram, id, quantity} = data;

  return (
    <Box
      display={"grid"}
      gridTemplateColumns={{
        base: "1fr",
        sm: "1fr",
        md: "1fr 2fr",
      }}
      borderBottom={"1px solid #eaeded"}
      height={"min-content"}
      margin={"0.75rem 0 0 0"}
    >
      <VStack
        pr={"5px"}
        alignItems={"left"}
        mb={"10px"}
        height={"95%"}
        w={"100%"}
        color={"#111b27"}
        padding={"0.5rem"}
        transition={"0.15s"}
        fontSize={"14px"}
      >
        <Text
          fontWeight={"500"}
          fontSize={"md"}
          textAlign={"left"}
          pr={"20px"}
          data-cy={"mobile-name"}
        >
          {name}
        </Text>
        <Box display={"flex"} gap={2} justifyContent={"space-between"}>
          <Box color={"#6b7280"}>
            <Text fontSize={"sm"} pr={"10px"} data-cy={"mobile-cpu"}>
              CPU : {cpu}
            </Text>
            <Text fontSize={"sm"} data-cy={"mobile-ram"}>
              RAM : {ram >= 1024 ? ram / 1024 + " GB" : ram + " MB"}
            </Text>
          </Box>
          <Box color={"#6b7280"}>
            <Box display={"flex"} alignItems={"center"} gap={2} color={"#6b7280"}>
              Qty
              <NumberInput.Root
                size="sm"
                maxW={20}
                value={quantity}
                min={0}
                onValueChange={({value}) => {
                  let n = Math.floor(Number(value));
                  if (n !== Infinity && n >= 0 && n !== quantity) {
                    quantityChangeFunction(n, id);
                  }
                }}
                data-cy={"mobile-quantity-input"}
              >
                <NumberInput.Control />
                <NumberInput.Input />
              </NumberInput.Root>
            </Box>
          </Box>
        </Box>
      </VStack>
    </Box>
  );
};

export default ProductCard;
